//
// Module for the Manual wizard's Federal Withholding tab on the Benefit Details step
//
rs.module("participant/benefit/setup/manual/wizard/benefitdetailstabs/federalwithholding",

    [
        "common/select-helper",
        "common/visibility",
        "pg/numerical-input"
    ],

    function (selectHelper, visibility, numericalInput) {

        // Initialize the module
        function initialize(jsSelectors, codeValues) {

            // get JS selectors
            var federalWithholdingTab = $.js(jsSelectors.federalWithholdingTab);

            var w4PChangeEffectiveDate = federalWithholdingTab.js(jsSelectors.w4PChangeEffectiveDate);

            var effectiveDateInput = federalWithholdingTab.js(jsSelectors.effectiveDateInput);
            var withholdingElectionSelect = federalWithholdingTab.js(jsSelectors.withholdingElectionSelect);

            var flatAmountInput = federalWithholdingTab.js(jsSelectors.flatAmountInput);
            var percentInput = federalWithholdingTab.js(jsSelectors.percentInput);
            var filingStatusSelect = federalWithholdingTab.js(jsSelectors.filingStatusSelect);
            var filingStatusSelectHelper = selectHelper.getHelper(filingStatusSelect);
            var allowancesField = federalWithholdingTab.js(jsSelectors.allowancesField);
            var allowancesInput = allowancesField.js(jsSelectors.allowancesInput);
            var extraWithholdingField = federalWithholdingTab.js(jsSelectors.extraWithholdingField);
            var extraWithholdingInput = extraWithholdingField.js(jsSelectors.extraWithholdingInput);

            var newFederalW4PFields = federalWithholdingTab.js(jsSelectors.newFederalW4PFields);

            var annualJobPayInput = newFederalW4PFields.js(jsSelectors.annualJobPayInput);
            var otherAnnualPensionInput = newFederalW4PFields.js(jsSelectors.otherAnnualPensionInput);
            var totalJobPensionIncomeInput = newFederalW4PFields.js(jsSelectors.totalJobPensionIncomeInput);

            var childDependentCreditInput = newFederalW4PFields.js(jsSelectors.childDependentCreditInput);
            var otherDependentCreditInput = newFederalW4PFields.js(jsSelectors.otherDependentCreditInput);
            var otherTaxCreditInput = newFederalW4PFields.js(jsSelectors.otherTaxCreditInput);
            var totalTaxCreditInput = newFederalW4PFields.js(jsSelectors.totalTaxCreditInput);

            var extraAmountPerPaymentInput = newFederalW4PFields.js(jsSelectors.extraAmountPerPaymentInput);

            // Customize jquery validation to conditionally apply validations
            _setupCustomValidation();

            numericalInput.registerSumInputs(totalJobPensionIncomeInput, 2, annualJobPayInput, otherAnnualPensionInput);

            numericalInput.registerSumInputs(totalTaxCreditInput, 2, childDependentCreditInput, otherDependentCreditInput, otherTaxCreditInput);

            // Re-populate state drop down options
            effectiveDateInput.change(_.debounce(function () {
                ToggleFederalW4PDisplay();
            }, 500));

            // Clear and disable the amount fields and re-enable appropriate fields based on selection
            withholdingElectionSelect.change(function () {
                _updateValidationScope(withholdingElectionSelect.val() != '');

                withholdingElectionSelect.clearErrors();
                ToggleAmountFields(withholdingElectionSelect.val());
                ToggleFederalW4PDisplay();
            });

            // Enable the appropriate fields based on the given election
            function ToggleAmountFields(electionCodeKey) {
                if (electionCodeKey == codeValues.flatAmount ||
                    electionCodeKey == codeValues.percent) {

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    extraAmountPerPaymentInput.val('').clearErrors();
                    extraAmountPerPaymentInput.prop('disabled', true);

                    if (electionCodeKey == codeValues.flatAmount) {
                        flatAmountInput.prop('disabled', false);

                        percentInput.val('').clearErrors();
                        percentInput.prop('disabled', true);
                    } else {
                        flatAmountInput.val('').clearErrors();
                        flatAmountInput.prop('disabled', true);

                        percentInput.prop('disabled', false);
                    }
                } else if (
                    electionCodeKey == codeValues.taxTable ||
                    electionCodeKey == codeValues.taxTablePlusExtra) {

                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentInput.val('').clearErrors();
                    percentInput.prop('disabled', true);

                    // enable applicable fields
                    filingStatusSelectHelper.setDisabled(false);
                    allowancesInput.prop('disabled', false);

                    if (electionCodeKey == codeValues.taxTable) {
                        extraWithholdingInput.val('').clearErrors();
                        extraWithholdingInput.prop('disabled', true);
                        extraAmountPerPaymentInput.val('').clearErrors();
                        extraAmountPerPaymentInput.prop('disabled', true);
                    } else {
                        extraWithholdingInput.prop('disabled', false);
                        extraAmountPerPaymentInput.prop('disabled', false);
                    }
                } else {
                    flatAmountInput.val('').clearErrors();
                    flatAmountInput.prop('disabled', true);

                    percentInput.val('').clearErrors();
                    percentInput.prop('disabled', true);

                    filingStatusSelectHelper.setValue('');
                    filingStatusSelect.clearErrors();
                    filingStatusSelectHelper.setDisabled(true);

                    allowancesInput.val('').clearErrors();
                    allowancesInput.prop('disabled', true);

                    extraWithholdingInput.val('').clearErrors();
                    extraWithholdingInput.prop('disabled', true);
                    extraAmountPerPaymentInput.val('').clearErrors();
                    extraAmountPerPaymentInput.prop('disabled', true);
                }
            }

            // Display appropriate fields based on if effective date is w4PChangeEffectiveDate or later
            function ToggleFederalW4PDisplay() {
                let showNewW4PFields = effectiveDateInput.val() == '' ||  new Date(effectiveDateInput.val() + 'T00:00:00') >= new Date(w4PChangeEffectiveDate.val());

                let taxTablePlusExtraSelected = withholdingElectionSelect.val() == codeValues.taxTablePlusExtra;
                let taxTableOptionSelected = taxTablePlusExtraSelected || withholdingElectionSelect.val() == codeValues.taxTable;
                let enableNewW4PFields = showNewW4PFields && taxTableOptionSelected;

                extraWithholdingInput.prop('disabled', !taxTablePlusExtraSelected || showNewW4PFields);
                extraAmountPerPaymentInput.prop('disabled', !taxTablePlusExtraSelected || !showNewW4PFields);

                visibility.setVisible(extraWithholdingField, !showNewW4PFields);

                visibility.setVisible(allowancesField, !showNewW4PFields);

                newFederalW4PFields.find('input').not(extraAmountPerPaymentInput).each(function () {
                    $(this).prop('disabled', !enableNewW4PFields);

                    if (!enableNewW4PFields) {
                        $(this).val('$0.00');
                    }
                });

                visibility.setVisible(newFederalW4PFields, showNewW4PFields);
            }

            // Update the data-val property of the federalWithholdingTab element so
            // the custom jquery validation "ignore" function can look at it
            function _updateValidationScope(validate) {
                federalWithholdingTab.data("val", validate);

                // Set the html attribute for data-val so css can see it
                federalWithholdingTab.attr('data-val', validate);
            }

            // Customize jqueryvalidation to possibly skip client-side validations if
            // the validationScope is configured to not validate its children
            function _setupCustomValidation() {
                var currentIgnoreFunction = $.validator.defaults.ignore;

                var overrides = {
                    ignore: function (index, element) {

                        var result = false;

                        if (currentIgnoreFunction) {
                            result = currentIgnoreFunction(index, element);
                        }

                        if (!result) {

                            var validationScope = $(element).closestjs(jsSelectors.federalWithholdingTab, { required: false });
                            if (validationScope.length > 0) {
                                result = validationScope.data("val") == false
                            }
                        }

                        return result;
                    }
                }

                // merge our overrides into the current active defaults
                $.validator.setDefaults(overrides);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);